import React from "react";

const ROLE_META = {
  owner: { label: "Besitzer", bg: "#F59E0B" },
  leader: { label: "Leiter", bg: "#F59E0B" },
  editor: { label: "Bearbeiten", bg: "#16A34A" },
  viewer: { label: "Lesen", bg: "#64748B" },
  member: { label: "Mitglied", bg: "#3B82F6" },
  "co-leader": { label: "Co-Leiter", bg: "#8B5CF6" },
  helper: { label: "Helfer", bg: "#14B8A6" },
};

export function RoleBadge({ role }) {
  const m = ROLE_META[role] || { label: role || "—", bg: "#64748B" };
  return (
    <span data-testid={`role-badge-${role}`}
      className="text-[10px] uppercase font-heading font-semibold px-2 py-0.5 rounded-full text-white shrink-0 whitespace-nowrap"
      style={{ background: m.bg }}>{m.label}</span>
  );
}
